/* eslint-disable react-hooks/exhaustive-deps */
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";
import { Link, useHistory } from "react-router-dom";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import { useSubheader } from "../../_metronic/layout";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { GoogleMap } from "../../_metronic/_partials/dashboards/GoogleMapComp";
import GoogleMapContainer from "../../_metronic/_partials/dashboards/GoogleMapComp copy";

import { Helmet } from "react-helmet";
import {
  ConvertToDateCurrentTimeZone,
  translateAuto,
} from "../../_metronic/_helpers/AtHelper";
import AttachementComp from "../modules/ECommerce/pages/products/LoadComponent/Attachement";
import moment from "moment";
const adapter = new LocalStorage("db");
const db = low(adapter);

export const Trackloads = () => {
  const history = useHistory();
  const [StatusActivity, setshowStatusActivity] = useState(false);
  const [SelectedLoadId, setSelectedLoadId] = useState(null);
  const [LoadIdsList, setLoadIdsList] = useState([]);
  const { t } = useTranslation();
  const suhbeader = useSubheader();
  suhbeader.setTitle(t("Track_Load"));

  const [LoadInformations, setLoadInformations] = useState(null);
  const [IsLoadingMapInfo, setIsLoadingMapInfo] = useState(false);
  const [LoadsPositionList, setLoadsPositionList] = useState([]);
  const [DetailTrakingGeometryInfo, setDetailTrakingGeometryInfo] = useState(
    []
  );

  function getLoadsPosition() {
    setIsLoadingMapInfo(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Tracking`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setLoadsPositionList(data?.Shipments || []);
        }
        setIsLoadingMapInfo(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoadingMapInfo(false);
      });
  }
  function getLoadInfo(params) {
    setIsLoadingMapInfo(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Tracking/${params}`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setLoadInformations(data);
          setDetailTrakingGeometryInfo(data?.Polyline || []);
        }
        setIsLoadingMapInfo(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoadingMapInfo(false);
      });
  }
  function GetLoadsIds() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Shipments/Ids`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setLoadIdsList(data.Ids || []);
        } else if (result[0] === 404) {
          history.push("/error/error-v1");
        } else if (result[0] === 402) {
          Swal.fire(t("Error"), translateAuto(result[1].Message), "error");
          history.push("/user-profile#billing");
        } else if (result[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  useEffect(() => {
    GetLoadsIds();
    getLoadsPosition();
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shipper | {t("Track_loads")}</title>
      </Helmet>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0">
          <Card>
            <div className="card-header pt-7">
              <div
                className="form-group fv-plugins-icon-container"
                style={{ width: "100%", zIndex: "2" }}
              >
                <ReactSelect
                  isSearchable={true}
                  isClearable
                  placeholder={t("Select_Load")}
                  value={LoadIdsList?.filter(
                    (a) => a.Id === SelectedLoadId
                  ).map((a) => {
                    return { label: a.Code, value: a.Id };
                  })}
                  options={LoadIdsList?.map((a) => {
                    return { label: a.Code, value: a.Id };
                  })}
                  onChange={(e) => {
                    if (e !== null) {
                      setSelectedLoadId(e?.value);
                      getLoadInfo(e?.value);
                    } else {
                      setSelectedLoadId(null);
                      setDetailTrakingGeometryInfo([]);
                      setLoadInformations(null);
                    }
                  }}
                />
              </div>
            </div>

            {SelectedLoadId === null ? (
              <CardBody className="text-center">
                <h4 className="text-muted font-weight-bolder">
                  {t("Please_Select_Load")}
                </h4>
              </CardBody>
            ) : (
              <CardBody>
                <div
                  className="scroll pt-5"
                  style={{ height: "350px", overflow: "auto" }}
                >
                  <>
                    <div className="timeline-item align-items-center mb-1">
                      <div className="timeline-line w-20px mt-9 mb-n14" />
                      <div
                        className="timeline-icon pt-1"
                        style={{ marginLeft: "0.7px" }}
                      >
                        <span className="svg-icon svg-icon-2 svg-icon-primary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Loads/Receiver.svg"
                            )}
                          ></SVG>
                        </span>
                        <span className="fs-8 font-weight-boldest text-primary text-uppercase">
                          {t("PickUp")} location
                        </span>
                      </div>
                      <div className="timeline-content mb-4">
                        <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0">
                          {LoadInformations?.Shipment?.ShippingCompany !==
                            undefined &&
                            LoadInformations?.Shipment?.ShippingCompany}
                        </p>
                        <span className="font-weight-bold text-gray-400">
                          {(LoadInformations?.Shipment?.ShippingAddress1 !==
                            undefined &&
                            LoadInformations?.Shipment?.ShippingAddress1 +
                              ", ") +
                            (LoadInformations?.Shipment?.ShippingCity !==
                              undefined &&
                              LoadInformations?.Shipment?.ShippingCity + ", ") +
                            (LoadInformations?.Shipment?.ShippingState !==
                              undefined &&
                              LoadInformations?.Shipment?.ShippingState + " ") +
                            (LoadInformations?.Shipment?.ShippingZipCode !==
                              undefined &&
                              LoadInformations?.Shipment?.ShippingZipCode) +
                            (LoadInformations?.Shipment?.ShippingCountry !==
                              undefined &&
                              ", " +
                                LoadInformations?.Shipment?.ShippingCountry)}
                        </span>
                      </div>
                    </div>
                    {LoadInformations?.Stops?.map((item, index) => {
                      return (
                        <div
                          className="timeline-item align-items-center"
                          key={index}
                        >
                          <div className="timeline-line w-20px" />
                          <div
                            className="timeline-icon pt-1"
                            style={{ marginLeft: "0.5px" }}
                          >
                            <span className="svg-icon svg-icon-2 svg-icon-warning">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Loads/Receiver.svg"
                                )}
                              ></SVG>
                            </span>
                            <span className="text-warning">
                              <span className="fs-3 font-weight-boldest text-warning text-uppercase">
                                {LoadInformations?.Shipment?.Mode === "Drayage"
                                  ? "Delivery location"
                                  : item.Type}
                              </span>{" "}
                              {LoadInformations?.Shipment?.Mode === "Drayage"
                                ? ""
                                : "Stop"}
                            </span>
                          </div>
                          <div className="timeline-content m-0">
                            <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0">
                              {item?.Name}
                            </p>

                            <span className="font-weight-bold text-gray-400">
                              {(item?.Address1 !== null &&
                                item?.Address1 + ", ") +
                                (item?.City !== null && item?.City + ", ") +
                                (item?.State !== null && item?.State + " ") +
                                (item?.Zipcode !== null &&
                                  item?.Zipcode + " ") +
                                (item?.Country !== null &&
                                  ", " + item?.Country)}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                    <div className="timeline-item align-items-center mt-4">
                      <div className="timeline-line w-20px" />
                      <div
                        className="timeline-icon pt-1"
                        style={{ marginLeft: "0.5px" }}
                      >
                        <span className="svg-icon svg-icon-2 svg-icon-info">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                              fill="currentColor"
                            />
                            <path
                              d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="fs-8 font-weight-boldest text-info text-uppercase">
                          {LoadInformations?.Shipment?.Mode === "Drayage" &&
                          LoadInformations?.Shipment?.IsStayWith === true
                            ? "Empty location"
                            : t("Destination")}
                        </span>
                      </div>
                      <div className="timeline-content m-0">
                        <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0">
                          {LoadInformations?.Shipment?.ReceivingCompany}
                        </p>

                        <span className="font-weight-bold text-gray-400">
                          {(LoadInformations?.Shipment?.ReceivingAddress1 !==
                            null &&
                            LoadInformations?.Shipment?.ReceivingAddress1 +
                              ", ") +
                            (LoadInformations?.Shipment?.ReceivingCity !==
                              null &&
                              LoadInformations?.Shipment?.ReceivingCity +
                                ", ") +
                            (LoadInformations?.Shipment?.ReceivingState !==
                              null &&
                              LoadInformations?.Shipment?.ReceivingState +
                                " ") +
                            LoadInformations?.Shipment?.ReceivingZipCode +
                            (LoadInformations?.Shipment?.ReceivingCountry !==
                              undefined &&
                              ", " +
                                LoadInformations?.Shipment?.ReceivingCountry)}
                        </span>
                      </div>
                    </div>
                  </>
                </div>
              </CardBody>
            )}
          </Card>
          {SelectedLoadId !== null && (
            <Card>
              <CardHeader title={t("Itinerary")}>
                <CardHeaderToolbar>
                  <div className="d-flex flex-column flex-grow-1">
                    <h3 className="card-title align-items-start flex-wrap mt-5 mb-0">
                      <span className="font-weight-bold text-muted font-size-sm">
                        {t("Load_Number")} #
                      </span>
                    </h3>
                    <h3 className="card-title align-items-start flex-wrap mt-0">
                      <span className="font-weight-bolder text-primary font-size-lg">
                        <Link
                          to={`/shipper/Loads/${LoadInformations?.Shipment?.Id}/edit`}
                        >
                          {LoadInformations?.Shipment?.Code}
                        </Link>
                      </span>
                    </h3>
                  </div>
                </CardHeaderToolbar>
              </CardHeader>
              <CardBody className="pl-2">
                <div
                  className="scroll  ps--active-y"
                  style={{ height: "770px", overflow: "scroll" }}
                >
                  <div className="timeline ml-n1 pl-1">
                    <div className="timeline-item align-items-center">
                      <div className="timeline-line w-20px mt-11 mb-n14" />
                      <div
                        className="timeline-icon pt-1"
                        style={{ marginLeft: "0.7px" }}
                      >
                        <span className="svg-icon svg-icon-2 svg-icon-primary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Loads/Receiver.svg"
                            )}
                          ></SVG>
                        </span>
                      </div>
                      <div className="timeline-content m-0">
                        <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0 mt-6">
                          {t("PickUp")} location
                          {LoadInformations?.Shipment?.ShippingDepartureDate !==
                          null
                            ? LoadInformations?.Shipment
                                ?.ShippingDepartureDate &&
                              ConvertToDateCurrentTimeZone(
                                LoadInformations?.Shipment
                                  ?.ShippingDepartureDate
                              )
                            : "---------- "}
                          <span
                            className="text-muted"
                            style={{
                              fontWeight: "100",
                              fontSize: "smaller",
                              display: "block",
                            }}
                          >
                            {(LoadInformations?.Shipment?.ShippingCity !== null
                              ? LoadInformations?.Shipment?.ShippingCity + ", "
                              : "") +
                              (LoadInformations?.Shipment?.ShippingState !==
                              null
                                ? LoadInformations?.Shipment?.ShippingState
                                : "")}
                          </span>
                        </p>
                      </div>
                    </div>
                    {LoadInformations?.Tracking?.map((item, index) => {
                      return (
                        <div
                          className="timeline-item align-items-center"
                          key={index}
                        >
                          <div className="timeline-line w-20px" />
                          <div
                            className="timeline-icon pt-1"
                            style={{ marginLeft: "0.5px" }}
                          >
                            <span className="svg-icon svg-icon-2 svg-icon-success">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Loads/Receiver.svg"
                                )}
                              ></SVG>
                            </span>
                          </div>
                          <div className="timeline-content m-0">
                            <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0 mt-6">
                              {item.EventName}:{" "}
                              {item.EventDate &&
                                ConvertToDateCurrentTimeZone(item.EventDate)}
                              <span
                                className="text-muted"
                                style={{
                                  fontWeight: "100",
                                  fontSize: "smaller",
                                  display: "block",
                                }}
                              >
                                {(item?.City !== null
                                  ? item?.City + ", "
                                  : "") +
                                  (item?.State !== null ? item?.State : "")}
                              </span>
                            </p>
                          </div>
                        </div>
                      );
                    })}
                    {LoadInformations?.Stops?.filter(
                      (a) => a.Delivered === false
                    )?.map((item, index) => {
                      return (
                        <div className="timeline-item align-items-center">
                          <div className="timeline-line w-20px" />
                          <div
                            className="timeline-icon pt-1"
                            style={{ marginLeft: "0.5px" }}
                          >
                            <span className="svg-icon svg-icon-2 svg-icon-warning">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Loads/Receiver.svg"
                                )}
                              ></SVG>
                            </span>
                          </div>
                          <div className="timeline-content m-0">
                            <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0 mt-6">
                              {item.EventName}
                              {item.EventDate && ":"}
                              {item.EventDate &&
                                ConvertToDateCurrentTimeZone(item.EventDate)}
                              <span className="text-warning">
                                {LoadInformations?.Shipment?.Mode === "Drayage"
                                  ? "Delivery location"
                                  : item.Type}
                                {LoadInformations?.Shipment?.Mode === "Drayage"
                                  ? ""
                                  : "Stop"}
                              </span>
                              <span
                                className="text-muted"
                                style={{
                                  fontWeight: "100",
                                  fontSize: "smaller",
                                  display: "block",
                                }}
                              >
                                {(item?.City !== null
                                  ? item?.City + ", "
                                  : "") +
                                  (item?.State !== null
                                    ? item?.State
                                    : "")}{" "}
                              </span>
                            </p>
                          </div>
                        </div>
                      );
                    })}
                    <div className="timeline-item align-items-center">
                      <div className="timeline-line w-20px" />
                      <div
                        className="timeline-icon pt-1"
                        style={{ marginLeft: "0.5px" }}
                      >
                        <span className="svg-icon svg-icon-2 svg-icon-info">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Loads/Receiver.svg"
                            )}
                          ></SVG>
                        </span>
                      </div>
                      <div className="timeline-content m-0">
                        <p className="font-size-md text-gray-800 font-weight-bolder d-block mb-0 mt-6">
                          {LoadInformations?.Shipment?.Mode === "Drayage" &&
                          LoadInformations?.Shipment?.IsStayWith === true
                            ? "Empty location"
                            : t("Destination") + " location"}
                          {LoadInformations?.Shipment?.ReceivingArrivalDate !==
                          null
                            ? LoadInformations?.Shipment
                                ?.ReceivingArrivalDate &&
                              ConvertToDateCurrentTimeZone(
                                LoadInformations?.Shipment?.ReceivingArrivalDate
                              )
                            : " ----------"}
                        </p>
                        <span
                          className="text-muted"
                          style={{
                            fontWeight: "100",
                            fontSize: "smaller",
                            display: "block",
                          }}
                        >
                          {(LoadInformations?.Shipment?.ReceivingCity !== null
                            ? LoadInformations?.Shipment?.ReceivingCity + ", "
                            : "") +
                            (LoadInformations?.Shipment?.ReceivingState !== null
                              ? LoadInformations?.Shipment?.ReceivingState +
                                ", "
                              : "")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          )}
        </div>
        <div className="flex-lg-row-fluid ml-lg-7 ml-xl-10">
          <div className="maps-section mb-5">
            {IsLoadingMapInfo === false ? (
              SelectedLoadId === null ? (
                LoadsPositionList.length > 0 && (
                  <GoogleMapContainer
                    LoadsPositionList={LoadsPositionList}
                    setSelectedLoadId={setSelectedLoadId}
                    SelectedLoadId={SelectedLoadId}
                    getLoadInfo={getLoadInfo}
                    isDashboard={false}
                    history={history}
                  />
                )
              ) : (
                <GoogleMap
                  setDetailTrakingGeometryInfo={setDetailTrakingGeometryInfo}
                  DetailTrakingGeometryInfo={DetailTrakingGeometryInfo}
                  LoadInformations={LoadInformations}
                />
              )
            ) : (
              <div className="d-flex justify-content-center mt-10">
                {t("Loading")} ...{" "}
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            )}
          </div>
          {SelectedLoadId !== null && (
            <Card>
              <CardHeader title={t("Load_info")}></CardHeader>
              <CardBody>
                <div className="d-flex justify-content-between">
                  <div className="d-flex flex-wrap">
                    <div className="d-flex flex-column">
                      {LoadInformations?.Shipment?.Mode === "Drayage" ? (
                        <>
                          <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                            LFD
                          </p>
                          <span className="text-dark-75 font-weight-bold">
                            {LoadInformations?.Shipment?.LastFreeDate !== null
                              ? moment(
                                  LoadInformations?.Shipment?.LastFreeDate
                                ).format("MM/DD/YYYY")
                              : "- - - -"}
                          </span>
                        </>
                      ) : (
                        <>
                          <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                            {t("Req_Ship_Date")}
                          </p>
                          <span className="text-dark-75 font-weight-bold">
                            {LoadInformations?.Shipment?.ReqShipDate !== null
                              ? moment(
                                  LoadInformations?.Shipment?.ReqShipDate
                                ).format("MM/DD/YYYY")
                              : "- - - -"}
                          </span>
                        </>
                      )}

                      <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                        {t("PU_Appointment")}
                      </p>
                      <span className="text-dark-75 font-weight-bold">
                        {LoadInformations?.Shipment?.PuAppointmentDate !== null
                          ? ConvertToDateCurrentTimeZone(
                              LoadInformations?.Shipment?.PuAppointmentDate
                            )
                          : "- - - -"}
                      </span>
                      <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                        {t("Departure_Date")}
                      </p>
                      <span className="text-dark-75 font-weight-bold">
                        {LoadInformations?.Shipment?.ShippingDepartureDate !==
                        null
                          ? ConvertToDateCurrentTimeZone(
                              LoadInformations?.Shipment?.ShippingDepartureDate
                            )
                          : "- - - -"}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center col-xl-5 col-lg-5 col-md-6 col-4">
                    <span className="svg-icon svg-icon-2 svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Loads/Receiver.svg"
                        )}
                      ></SVG>
                    </span>
                    <div className="d-flex flex-column flex-grow-1">
                      {LoadInformations?.Shipment?.Alert !== null &&
                      LoadInformations?.Shipment?.Alert !== undefined &&
                      LoadInformations?.Shipment?.Alert !== "" ? (
                        <span className="alert-loads">
                          <OverlayTrigger
                            overlay={
                              <Tooltip
                                style={{ pointerEvents: "none" }}
                                id="products-delete-tooltip"
                              >
                                {LoadInformations?.Shipment?.Alert}
                              </Tooltip>
                            }
                          >
                            <i className="fa fa-exclamation-triangle text-danger icon-xl"></i>
                          </OverlayTrigger>
                        </span>
                      ) : (
                        ""
                      )}
                      {LoadInformations?.Shipment?.Mode === "Drayage" &&
                      LoadInformations?.Shipment?.IsStayWith === true ? (
                        <>
                          <span
                            className="alert-loads"
                            style={{ transform: "translate(243px, -10px)" }}
                          >
                            <OverlayTrigger
                              overlay={
                                <Tooltip
                                  style={{ pointerEvents: "none" }}
                                  id="products-delete-tooltip"
                                >
                                  <div className="d-flex flex-column">
                                    <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                                      MABD
                                    </p>
                                    <span className="text-dark-75 font-weight-bold">
                                      {LoadInformations?.Stops[0]?.Mabd !== null
                                        ? ConvertToDateCurrentTimeZone(
                                            LoadInformations?.Stops[0]?.Mabd
                                          )
                                        : "- - - -"}
                                    </span>

                                    <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                                      Empty date
                                    </p>
                                    <span className="text-dark-75 font-weight-bold">
                                      {LoadInformations?.Stops[0]?.EmptyDate !==
                                      null
                                        ? ConvertToDateCurrentTimeZone(
                                            LoadInformations?.Stops[0]
                                              ?.EmptyDate
                                          )
                                        : "- - - -"}
                                    </span>
                                    <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                                      Pu appointment date
                                    </p>
                                    <span className="text-dark-75 font-weight-bold">
                                      {LoadInformations?.Stops[0]
                                        ?.PuAppointmentDate !== null
                                        ? ConvertToDateCurrentTimeZone(
                                            LoadInformations?.Stops[0]
                                              ?.PuAppointmentDate
                                          )
                                        : "- - - -"}
                                    </span>
                                  </div>
                                </Tooltip>
                              }
                            >
                              <span className="svg-icon svg-icon-lg svg-icon-warning ">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Loads/Receiver.svg"
                                  )}
                                ></SVG>
                              </span>
                            </OverlayTrigger>
                          </span>
                        </>
                      ) : (
                        ""
                      )}

                      <span className="separator separator-dashed separator-border-2 separator-secondary" />
                    </div>
                    <span className="svg-icon svg-icon-2 svg-icon-info">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                          fill="currentColor"
                        />
                        <path
                          d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </div>

                  <div className="d-flex flex-wrap">
                    <div className="d-flex flex-column flex-grow-1">
                      {LoadInformations?.Shipment?.Mode === "Drayage" &&
                      LoadInformations?.Shipment?.IsStayWith === true ? (
                        <>
                          <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                            Reported empty
                          </p>
                          <span className="text-dark-75 font-weight-bold">
                            {LoadInformations?.Shipment?.ReportedEmpty !== null
                              ? moment(
                                  LoadInformations?.Shipment?.ReportedEmpty
                                ).format("MM/DD/YYYY")
                              : "- - - -"}
                          </span>
                        </>
                      ) : (
                        <>
                          <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                            MABD
                          </p>
                          <span className="text-dark-75 font-weight-bold">
                            {LoadInformations?.Shipment?.Mabd !== null
                              ? moment(LoadInformations?.Shipment?.Mabd).format(
                                  "MM/DD/YYYY"
                                )
                              : "- - - -"}
                          </span>
                        </>
                      )}

                      <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                        {t("Del_Appointment")}
                      </p>
                      <span className="text-dark-75 font-weight-bold">
                        {LoadInformations?.Shipment?.DelAppointmentDate !== null
                          ? ConvertToDateCurrentTimeZone(
                              LoadInformations?.Shipment?.DelAppointmentDate
                            )
                          : "- - - -"}
                      </span>
                      <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1 mt-3">
                        {t("Receiving_Arrival")}
                      </p>
                      <span className="text-dark-75 font-weight-bold">
                        {LoadInformations?.Shipment?.ReceivingArrivalDate !==
                        null
                          ? ConvertToDateCurrentTimeZone(
                              LoadInformations?.Shipment?.ReceivingArrivalDate
                            )
                          : "- - - -"}
                      </span>
                    </div>
                  </div>
                </div>
                <Col xl="12">
                  <Row className="align-items-center mt-10">
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Equipment_Type")}
                        </p>
                        <span className="text-dark-75 font-weight-bold">
                          {LoadInformations?.Shipment?.EquipmentType}
                        </span>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Total_Weight")}
                        </p>
                        <span className="text-dark-75 font-weight-bold">
                          {LoadInformations?.Shipment?.TotalWeight !== null
                            ? LoadInformations?.Shipment?.TotalWeight +
                              " " +
                              (LoadInformations?.Shipment?.WeightType !== null
                                ? LoadInformations?.Shipment?.WeightType
                                : "")
                            : ""}
                        </span>
                      </div>
                    </Fragment>

                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Total_Stops")}
                        </p>
                        <span className="text-dark-75 font-weight-bold">
                          {LoadInformations?.Shipment?.StopsCount || 0}
                        </span>
                      </div>
                    </Fragment>

                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Total_Price")}
                        </p>
                        <span className="text-dark-75 font-weight-bold">
                          $ {LoadInformations?.Shipment?.TotalPrice}
                        </span>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Distance_Mile")}
                        </p>
                        <span className="text-dark-75 font-weight-bold">
                          {LoadInformations?.Shipment?.TotalMiles} miles
                        </span>
                      </div>
                    </Fragment>
                  </Row>
                </Col>
                <Col xl="12">
                  <Row className="align-items-center mt-10">
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Trucker")}
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Trucker?.Name}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Email")}
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Trucker?.ContactEmail}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Licence")} #
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Trucker?.LicenceNumber}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                    <Fragment>
                      {/* <div className="d-flex flex-column flex-grow-1">
                          <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                            {t("Work_Phone")} #
                          </p>
                          <div className="mb-10">
                            <span className="font-weight-bolder text-dark-75 font-size-md">
                              {LoadInformations?.Trucker?.WorkPhoneNumber}
                            </span>
                          </div>
                        </div> */}
                    </Fragment>
                  </Row>
                  <Row>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Seal_Number")} #
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Shipment?.SealNumber}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Truck_Number")} #
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Shipment?.TruckNumber}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                    <Fragment>
                      <div className="d-flex flex-column flex-grow-1">
                        <p className="font-weight-bold text-muted text-hover-muted font-size-sm mb-1">
                          {t("Trailer_Number")} #
                        </p>
                        <div className="mb-10">
                          <span className="font-weight-bolder text-dark-75 font-size-md">
                            {LoadInformations?.Shipment?.TrailerNumber}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                  </Row>
                </Col>
              </CardBody>
            </Card>
          )}
          {SelectedLoadId !== null && (
            <Row>
              <Col lg="12">
                <AttachementComp
                  id={SelectedLoadId}
                  IsDetailsMode={true}
                  isTruckerDetails={true}
                />
              </Col>
            </Row>
          )}
        </div>
      </div>
      <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
        <OverlayTrigger
          placement="left"
          overlay={<Tooltip id="layout-tooltip">{t("Status_History")}</Tooltip>}
        >
          <li className="nav-item mb-2" data-placement="left">
            <button
              onClick={() => {
                setshowStatusActivity(true);
              }}
              type="button"
              className="btn btn-sm btn-icon btn-bg-light"
            >
              <i className="fas fa-history text-warning"></i>
            </button>
          </li>
        </OverlayTrigger>
      </ul>
      <Modal
        size="sm"
        show={StatusActivity}
        onHide={() => {
          setshowStatusActivity(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Status_History")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="Hisory-status">
          <Fragment>
            <div className="d-flex flex-column flex-grow-1">
              {LoadInformations?.StatusesHistoy.length > 0 ? (
                LoadInformations?.StatusesHistoy?.map((item, index) => {
                  return (
                    <div
                      className="timeline timeline-6 mt-3 scroll align-self-start"
                      key={String(index)}
                    >
                      <div
                        className="timeline-item align-items-start"
                        key={index}
                      >
                        <div className="timeline-label font-weight-mormal text-muted font-size-lg">
                          {item?.Created &&
                            ConvertToDateCurrentTimeZone(item?.Created)}
                        </div>
                        <div className="timeline-badge">
                          <i className="fa fa-genderless text-warning icon-xl" />
                        </div>

                        <div className="font-weight-bolder font-size-lg timeline-content text-dark-75 pl-3">
                          {item?.Name}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <h4>{t("no_data_available")}</h4>
              )}
            </div>
          </Fragment>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setshowStatusActivity(false);
            }}
          >
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
